<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

<h1>Keycloak User Migration</h1>

<!-- Keycloak to IDM Coversion Form -->
<form class="mt-3" role="form" novalidate #form="ngForm" method="post" (ngSubmit)="run()">

    <!-- Customer, Env and Corporation row -->
    <div class="row">

        <div class="col-md-4 col-xs-1">
            <div class="form-group input-required">
                <label for="customer">Customer</label>
                <select2 required [settings]="{ placeholder: 'Not Selected', width: '100%' }" id="customer"  name="customer" [options]="customers" [(ngModel)]="customer" (onSelect)="customerChanged($event)">
                </select2>
            </div>
        </div>

        <div class="col-md-4 col-xs-1">
            <div class="form-group input-required">
                <label for="environment">Environment</label>
                <select2 required [settings]="{ placeholder: 'Not Selected', width: '100%' }" id="environment" name="environment" [options]="environments" [(ngModel)]="environment" (onSelect)="environmentChanged($event)">
                </select2>
            </div>
        </div>

        <div class="col-md-4 col-xs-1">
            <div class="form-group input-required">
                <label for="corporation">Corporation</label>
                <select2 required [settings]="{ placeholder: 'Not Selected', width: '100%' }" id="corporation" name="corporation" [options]="corporations" [(ngModel)]="corporation" (onSelect)="corporationChanged($event)">
                </select2>
            </div>
        </div>

    </div>

    <!-- Checkbox row to include more users -->
    <div class="row">
        <div class="ml-3 mt-3 form-check form-check-inline">
            <input name="inactiveUsers" [(ngModel)]="inactiveUsers" class="form-check-input" id="inactiveUsers" type="checkbox" value="" />
            <label class="form-check-label" for="inactiveUsers">
              Include in-active users
              <small>(
                This applies to MatrixCare 360 user status.
                Most customers may not prefer to migrate in-active users.
              )</small>
            </label>
        </div>
    </div>

    <!-- Search Users -->
    <div class="row mt-3">
        <div class="col-12">
            <button type="button" (click)="back()" class="btn btn-default">
                Back
            </button>
            <button type="submit" class="btn btn-primary" [disabled]="!form.valid">
                Search Users
            </button>
            <button type="button" class="btn btn-default mr-3" (click)="reset()">
                Clear Fields
            </button>
        </div>
    </div>

    <!-- Conversion Table -->
    <div [hidden]="!unfilteredData">
        <div class="row mt-5">
          <div class="col-12 form-group">
            <span class="button-container"> </span>
            <button (click)="import()" [disabled]="unfilteredData == 0" *ngIf="isKeycloakImportUser" type="button"  class="btn btn-primary">
              Import Keycloak to IDM
            </button>
            <div class="ml-3 form-check form-check-inline">
              <input name="onlyErrors" (change)="onlyErrorsChanged($event)" [(ngModel)]="onlyErrors" class="form-check-input" id="onlyErrors" type="checkbox" value="" />
              <label class="form-check-label" for="onlyErrors">Only show users with errors</label>
            </div>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col-8">
            Pre Migration readiness for users in the list bellow ({{  numberOfErrors == 0   ? "no errors"  : numberOfErrors + " unresolved errors" }} out of {{ unfilteredData?.length }} users)
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-md-8">
            <div class="progress">
              <div class="progress-bar" *ngIf="errorPercentage != 0" [style.width.%]="errorPercentage" role="progressbar" aria-valuenow="{{ errorPercentage }}" aria-valuemin="0" aria-valuemax="100">
                {{ errorPercentage | number }}%
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" [hidden]="!unfilteredData">
        <div class="col-12">
          <table class="table table-bordered table-striped table-fit" id="resultsDataTable"></table>
        </div>
      </div>
</form>
